import notification from "antd/lib/notification";
import Select from "antd/lib/select";
import React, { useEffect } from "react";
import { useState } from "react";

import { LoadingOutlined } from "@ant-design/icons";
import Header from "../components/menu/Header";
import Mentorbox from "../components/Mentorbox";
import QalortFooter from "../components/QalortFooter";
import { useCategories } from "../hooks/useCategories";
import { useMentors } from "../hooks/useMentors";
import { FilterMentors } from "../services/AppointmentsService";
import Empty from "../components/Empty";
import SEO from "../components/Seo";
import Tour from "reactour";

function Mentors() {
  const mentorTour = "mentorTour";
  const [isOpen, setIsOpen] = useState(false);
  const [steps, setSteps] = useState([]);
  const [isloading, setLoading] = useState(null);
  const categories = useCategories();
  const { data: mentors, isLoading: loading } = useMentors();
  const [results, setResults] = useState([]);

  const getForm = async (category_id) => {
    if (category_id === "All categories") {
      setResults(mentors);
      return;
    }
    setLoading(true);
    try {
      const res = await FilterMentors({
        category_id,
        // topic_id: vals.topic,
      });
      setResults(res?.data?.data || []);
    } catch (e) {
      notification.error({
        description: e.response.data.message || "An error occured",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    !loading && setResults(mentors);
  }, [mentors]);

  useEffect(() => {
    if (!loading && mentors?.length && !localStorage.getItem(mentorTour)) {
      setSteps([
        {
          selector: ".mentors",
          content: "Find more mentors in other fields here.",
        },
      ]);
      setTimeout(() => {
        setIsOpen(true);
      }, 1000);
    }
  }, [loading]);

  const closeTour = () => {
    setIsOpen(false);
    localStorage.setItem(mentorTour, "true");
  };

  return (
    <div>
      <Tour steps={steps} isOpen={isOpen} onRequestClose={closeTour} />
      <SEO />
      <Header mentor />
      <div className="flex flex-col bg-pri-tint-3 light-grad pt-10 sm:pt-[140px] pb-10 text-center app-container">
        <div className="app-container-section">
          <h1 id="montor_header" className="text-dark mb-0">
            Mentor's World
          </h1>
          <h6 id="montor_subheader" className="text-main mx-auto mt-3.5 mb-6">
            Discover amazing Mentors and learn from the best
          </h6>

          <form
            onSubmit={(e) => {
              e.preventDefault();
              getForm();
            }}
            className="filter-wrap justify-between rounded-lg border-1 mx-auto bg-white flex h-12 overflow-hidden"
          >
            <div className="flex w-full">
              <div className="w-full">
                <Select
                  loading={isloading}
                  placeholder="Select category"
                  style={{ width: "100%", height: "100%" }}
                  bordered={false}
                  onChange={(e) => getForm(e)}
                  options={[
                    {
                      value: "All categories",
                      label: "All categories",
                    },
                    ...categories?.map((ctg) => {
                      return {
                        ...ctg,
                        label: ctg.category,
                        value: ctg._id,
                      };
                    }),
                  ]}
                />
              </div>
              {/* <div className="flex border-l-1 ml-2">
                <img
                  src={`${getImageBaseUrl}/assets/search.svg`}
                  className="w-4 ml-4"
                  alt=""
                />
                <input
                  name="topic"
                  type="text"
                  placeholder="Search by topics"
                  className="border-0 w-20 sm:w-96 pl-3 focus:outline-none"
                  value={topic}
                  onChange={(e) => setTopic(e.target.value)}
                />
              </div> */}
              {/* <button
                disabled={loading}
                type="submit"
                className="bg-pri text-white px-4 md:px-6 py-3 p-sm hidden sm:block"
              >
                Search
              </button> */}
            </div>
          </form>
        </div>
      </div>

      <div className="mentors-wrap mt-12 mb-[74px] app-container">
        <div className="app-container-section ">
          {!loading ? (
            <>
              <h4 className="text-dark mb-6 mentors">Our Mentors</h4>
              <div className="grid grid-cols-1 gap-[25px] sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 sm:gap-6 sm:gap-y-8">
                <>
                  {mentors?.map((mentor, j) => (
                    <div className="w-full h-[420px]" key={j}>
                      <Mentorbox mentor={mentor} />
                    </div>
                  ))}
                </>
              </div>
            </>
          ) : (
            <div className="w-full h-[420px] flex justify-center items-center">
              <LoadingOutlined className="text-[30px]" />
            </div>
          )}

          {!mentors?.length && !loading && (
            <Empty title={"No mentors fit your search criteria"} />
          )}
        </div>
      </div>

      <QalortFooter />
    </div>
  );
}

export default Mentors;
